import React from 'react'
import { Typography } from '@material-ui/core'
import validacoesCnhRepository from './ValidacoesCnhRepository'
import RequisicaoCard from '../RequisicaoCard'
import moment from 'moment'

const ValidacaoCnhCard = ({
  match,
  cpf,
  numRegistro,
  numSeguranca,
  nome,
  nomeMae,
  disabled,
  validData,
  warningMessage = '',
  validateFieldName,
  dataValidade,
  dataEmissao,
  categoria
}) => {
  const transform = query => ({
    ...query,
    cpf,
    numRegistro,
    numSeguranca,
    nome,
    nomeMae,
    dataValidade,
    dataEmissao,
    categoria
  })

  const transformGet = query => ({
    ...query
  })

  const validateData = data => {
    let message = ''
    if (data) {
      const isSameName = data?.nomeCondutor === 'SIM'
      const isSameMomName = data?.nomeMae === 'SIM'

      const dataValidadeFromValidacao = moment(data.dataValidade).format(
        'DD/MM/YYYY'
      )
      const dataValidadeFromForm = moment(dataValidade).format('DD/MM/YYYY')
      const isSameDataValidade =
        dataValidadeFromValidacao === dataValidadeFromForm

      const dataEmissaoFromValidacao = moment(data.dataEmissao).format(
        'DD/MM/YYYY'
      )
      const dataEmissaoFromForm = moment(dataEmissao).format('DD/MM/YYYY')
      const isSameDataEmissao = dataEmissaoFromValidacao === dataEmissaoFromForm

      const isSameCategoria = data.categoria === categoria

      const isCnhValid = moment(dataValidade).isAfter(moment())

      const today = moment()
      const thirtyDaysBefore = today
        .clone()
        .subtract(30, 'days')
        .startOf('day')
      const endDateOfToday = today.clone().endOf('day')
      const isCnhBetweenRange = moment(dataValidadeFromValidacao).isBetween(
        thirtyDaysBefore,
        endDateOfToday
      )
      const cnhSituacaoValida = data.situacao === 'válida'
      const cnhSituacaoExisteMaisRecente =
        data.situacao === 'Existe uma cnh mais recente'

      if (!isSameName) {
        message += 'Nome do condutor não confere. '
      }

      if (!isSameMomName) {
        message += 'Nome da mãe não confere. '
      }

      if (!isSameDataValidade) {
        message += 'Data de validade não confere. '
      }

      if (!isSameDataEmissao) {
        message += 'Data de emissão não confere. '
      }

      if (!isSameCategoria) {
        message += 'Categoria não confere. '
      }

      if (!isCnhValid) {
        message += 'CNH expirada. '
      }

      if (!cnhSituacaoValida) {
        message += 'CNH não é válida. '
      }

      if (cnhSituacaoExisteMaisRecente) {
        message += 'Existe uma cnh mais recente. '
      }

      if (data.categoria.includes('C') || data.categoria.includes('D')) {
        message += 'CNH tipo C/D. '
      }

      if (isCnhBetweenRange) {
        message += 'CNH expirou a menos de 30 dias. '
      }

      if (
        isSameName &&
        isSameMomName &&
        isSameDataValidade &&
        isSameDataEmissao &&
        isSameCategoria &&
        isCnhValid &&
        data.situacao === 'válida' &&
        data.categoria.includes('E')
      ) {
        return { status: 'SUCCESS', message: '' }
      }

      if (
        isSameName &&
        isSameDataValidade &&
        isSameCategoria &&
        data.situacao === 'Existe uma cnh mais recente' &&
        (data.categoria.includes('C') ||
          data.categoria.includes('D') ||
          isCnhBetweenRange)
      ) {
        return { status: 'WARNING', message: message.trim() }
      }
    }

    return { status: 'ERROR', message: message.trim() }
  }

  return (
    <RequisicaoCard
      title="Validação CNH"
      match={match}
      repository={validacoesCnhRepository}
      transformManualFetch={transform}
      transformQuery={transformGet}
      disabled={disabled}
      validData={validData}
      warningMessage={warningMessage}
      validateFieldName={validateFieldName}
      validateData={validateData}
    >
      {data => (
        <>
          {data.situacao && (
            <Typography>
              <b>Situação:</b> {data.situacao}
            </Typography>
          )}
          {data.nomeCondutor && (
            <Typography>
              <b>Condutor:</b> {data.nomeCondutor}
            </Typography>
          )}
          {data.nomeMae && (
            <Typography>
              <b>Nome da mãe:</b> {data.nomeMae}
            </Typography>
          )}
          {data.categoria && (
            <Typography>
              <b>Categoria:</b> {data.categoria}
            </Typography>
          )}
          {data.dataEmissao && (
            <Typography>
              <b>Data Emissão:</b>{' '}
              {moment(data.dataEmissao).format('DD/MM/YYYY')}
            </Typography>
          )}
          {data.dataValidade && (
            <Typography>
              <b>Data Validade:</b>{' '}
              {moment(data.dataValidade).format('DD/MM/YYYY')}
            </Typography>
          )}
        </>
      )}
    </RequisicaoCard>
  )
}

export default React.memo(ValidacaoCnhCard)
